import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  OnInit,
  ViewChild
} from '@angular/core'
import { IonicModule, ModalController } from '@ionic/angular'
import { CommonModule } from '@angular/common'
import { Store } from '@ngrx/store'
import { take } from 'rxjs/operators'
import { selectProfile } from '@core/store/selectors/user.selectors'
import { UserProfile } from '@core/auth/models/auth.models'
import { ButtonComponent } from '@shared/components/button/button.component'
import { TranslatePipe } from '@ngx-translate/core'
import { STEPS } from '@features/onboarding/constants/onboarding.constants'
import { SwiperDirective } from '@shared/components/swiper-tabs/directives/swiper.directive'
import { saveUserProfile } from '@core/store/actions/profile.actions'

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, ButtonComponent, TranslatePipe, SwiperDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingComponent implements OnInit {
  private readonly _modalCtrl = inject(ModalController)
  private readonly _store = inject(Store)

  private _currentProfile: UserProfile | undefined

  @ViewChild('swiper') swiperRef: ElementRef | undefined

  protected readonly STEPS = STEPS
  isLastStep = false
  initialSlide = 0

  ngOnInit(): void {
    this._store
      .select(selectProfile)
      .pipe(take(1))
      .subscribe((profile) => {
        this._currentProfile = profile
        const step = profile?.onBoardingStep || 0
        this.initialSlide = step > 1 ? step - 1 : 0
        this.isLastStep = this.initialSlide === STEPS.length - 1
      })
  }

  onSlideChange(index: number): void {
    this.initialSlide = index
    this.isLastStep = index === STEPS.length - 1
  }

  nextStep(): void {
    const swiper = this.swiperRef?.nativeElement.swiper
    if (this.isLastStep) {
      this._closeAndSave(1)
    } else {
      swiper.slideNext()
    }
  }

  skipOnboarding(): void {
    const currentSlideIndex = this.swiperRef?.nativeElement.swiper?.activeIndex ?? this.initialSlide
    const stepToSave = STEPS[currentSlideIndex].stepNumber

    this._closeAndSave(stepToSave)
  }

  private _closeAndSave(step: number): void {
    if (this._currentProfile) {
      const updatedProfile: UserProfile = {
        ...this._currentProfile,
        onBoardingStep: step
      }
      this._store.dispatch(saveUserProfile({ profile: updatedProfile }))
    }

    this._modalCtrl.dismiss()
  }
}
